import { Show, createSignal } from "solid-js";
import { t } from "../i18n";

interface Props {
  notes: string | null | undefined;
  /** Characters before "show more" (default 90). */
  maxLen?: number;
  class?: string;
}

/** Compact exercise note with expand for long text. */
export default function ExerciseNote(props: Props) {
  const [open, setOpen] = createSignal(false);
  const text = () => props.notes?.trim() ?? "";
  const max = () => props.maxLen ?? 90;
  const long = () => text().length > max();
  const shown = () =>
    open() || !long() ? text() : `${text().slice(0, max()).trimEnd()}…`;

  return (
    <Show when={text()}>
      <div class={`text-xs leading-relaxed text-ink-muted ${props.class ?? ""}`}>
        <p class="whitespace-pre-wrap">{shown()}</p>
        <Show when={long()}>
          <button
            type="button"
            class="mt-0.5 font-medium text-accent hover:underline"
            onClick={() => setOpen((v) => !v)}
          >
            {open() ? t("SHOW_LESS") : t("SHOW_MORE")}
          </button>
        </Show>
      </div>
    </Show>
  );
}
